import { NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { WebsiteService } from '@shared/services/website.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  standalone: true,
  imports: [TranslocoModule, NgIf, NgFor],
  styleUrls: ['./privacy.component.scss'],
})
export class PrivacyComponent implements OnInit {
  public _websiteService = inject(WebsiteService);

  language: string = 'ar';
  ENData = [
    {
      cookieKey: 'li_gc',
      domain: '.linkedin.com',
      description:
        'Used to store guest consent to the use of cookies for non-essential purposes',
    },
    {
      cookieKey: 'X-AB',
      domain: 'sc-static.net',
      description: `This cookie is used by the website’s operator in context with multi-variate testing. This is a tool used to
    combine or change content on the
    website. This allows the website to
    find the best variation/edition of the
    site.`,
    },
    {
      cookieKey: 'AnalyticsSyncHistory',
      domain: '.linkedin.com',
      description: `Used to store information about the
    time a sync with the lms_analytics
    cookie took place for users in the
    Designated Countries`,
    },
    {
      cookieKey: '_gid',
      domain: '.HALA.com',
      description: `This cookie is set by Google
    Analytics. It stores and updates a unique value for each page visited
    and is used to count and track
    pageviews.`,
    },
    {
      cookieKey: '_ga_GVSEJ9RBSQ',
      domain: '.HALA.com',
      description: `This cookie is used by Google
    Analytics to persist session state.`,
    },
    {
      cookieKey: '_ga',
      domain: '.HALA.com',
      description: `This cookie name is associated with
    Google Universal Analytics - which
    is a significant update to Google's
    more commonly used analytics
    service. This cookie is used to
    distinguish unique users by
    assigning a randomly generated
    number as a client identifier. It is
    included in each page request in a
    site and used to calculate visitor,
    session, and campaign data for the
    sites analytics reports.`,
    },
    {
      cookieKey: '_ga_E8JBXT22RD',
      domain: '.HALA.com',
      description: `This cookie is used by Google
      Analytics to persist session state`,
    },
    {
      cookieKey: '_ga_SVEVR9N0W4',
      domain: '.HALA.com',
      description: `This cookie is used by Google
        Analytics to persist session state`,
    },
    {
      cookieKey: 'lidc',
      domain: '.linkedin.com',
      description: `This is a Microsoft MSN 1st party
          cookie that ensures the proper
          functioning of this website.`,
    },
    {
      cookieKey: '_gat_gtag_UA_252393352_1',
      domain: '.HALA.com',
      description: `This cookie is part of Google
            Analytics and is used to limit
            requests (throttle request rate).`,
    },
    {
      cookieKey: 'CLID',
      domain: 'www.clarity.ms',
      description: `This cookie is usually set by Dstillery
              to enable sharing media content to social media. It may also gather
              information on website visitors
              when they use social media to share
              website content from the page
              visited.`,
    },
    {
      cookieKey: 'MUID',
      domain: '.clarity.ms',
      description: `This cookie is widely used by
                Microsoft as a unique user identifier.
                It can be set by embedded Microsoft
                scripts. Widely believed to sync
                across many different Microsoft
                domains, allowing user tracking.`,
    },
    {
      cookieKey: '_scid',
      domain: '.HALA.com',
      description: `Used to help identify a visitor.`,
    },

    {
      cookieKey: 'MR',
      domain: '.c.bing.com',
      description: `This is a Microsoft MSN 1st party
                  cookie which is used to measure the
                  use of the website for internal
                  analytics.`,
    },
    {
      cookieKey: 'bcookie',
      domain: '.linkedin.com',
      description: `This is a Microsoft MSN 1st party
                    cookie for sharing the content of the
                    website via social media.`,
    },

    {
      cookieKey: 'guest_id',
      domain: '.twitter.com',
      description: `This cookie is set by Twitter to
                      identify and track the website visitor.`,
    },
    {
      cookieKey: 'SRM_B',
      domain: '.c.bing.com',
      description: `This is a Microsoft MSN 1st party
                        cookie that ensures the proper
                        functioning of this website.`,
    },
    {
      cookieKey: 'SM',
      domain: '.c.clarity.ms',
      description: `This is a Microsoft MSN 1st party
                          cookie which is used to measure the
                          use of the website for internal
                          analytics.`,
    },

    {
      cookieKey: '_gcl_au',
      domain: '.HALA.com',
      description: `Used by Google AdSense for
                            experimenting with advertisement
                            efficiency across websites using their
                            services.`,
    },
    {
      cookieKey: 'test_cookie',
      domain: '.doubleclick.net',
      description: `This cookie is set by DoubleClick
                              (owned by Google) to determine if
                              the website visitor's browser
                              supports cookies.`,
    },
    {
      cookieKey: 'bscookie',
      domain: '.www.linkedin.com',
      description: `Used by the social networking
      service, LinkedIn, for tracking the
      use of embedded services.`,
    },
    {
      cookieKey: 'MR',
      domain: '.c.clarity.ms',
      description: `This is a Microsoft MSN 1st party
        cookie which is used to measure the
        use of the website for internal
        analytics.`,
    },
    {
      cookieKey: 'personalization_id',
      domain: '.twitter.com',
      description: `This cookie carries out information
          about how the end user uses the
          website and any advertising that the
          end user may have seen before
          visiting the said website.`,
    },
    {
      cookieKey: 'sc_at',
      domain: '.snapchat.com',
      description: `Used to identify a visitor across
            multiple domains`,
    },
    {
      cookieKey: 'IDE',
      domain: '.doubleclick.net',
      description: `This cookie is set by Doubleclick and
              carries out information about how
              the end user uses the website and
              any advertising that the end user
              may have seen before visiting the
              said website.
              `,
    },
    {
      cookieKey: '_gat_gtag_UA_252393352_2',
      domain: '.HALA.com',
      description: `This cookie is part of Google
                Analytics and is used to limit
                requests (throttle request rate).
                `,
    },
    {
      cookieKey: '_fbp',
      domain: '.HALA.com',
      description: `Used by Meta to deliver a series of
                  advertisement products such as real
                  time bidding from third party
                  advertisers.`,
    },
    {
      cookieKey: 'UserMatchHistory',
      domain: '.linkedin.com',
      description: `This cookie is used to track visitors
                    so that more relevant ads can be
                    presented based on the visitor's
                    preferences.`,
    },
    {
      cookieKey: 'MUID',
      domain: '.bing.com',
      description: `This cookie is widely used by
                      Microsoft as a unique user identifier.
                      It can be set by embedded Microsoft
                      scripts. Widely believed to sync
                      across many different Microsoft
                      domains, allowing user tracking.`,
    },

    {
      cookieKey: 'ANONCHK',
      domain: '.c.clarity.ms',
      description: `This cookie carries out information
                        about how the end user uses the
                        website and any advertising that the
                        end user may have seen before
                        visiting the said website.`,
    },
    {
      cookieKey: 'guest_id_marketing',
      domain: '.twitter.com',
      description: `twitter pixel`,
    },

    {
      cookieKey: 'guest_id_ads',
      domain: '.twitter.com',
      description: `twitter pixel`,
    },
    {
      cookieKey: '_ttp',
      domain: '.tiktok.com',
      description: `tiktok pixel`,
    },
  ];

  ARData = [
    {
      cookieKey: 'li_gc',
      domain: '.linkedin.com',
      description: `ﯾﺳﺗﺧدم ﻟﺗﺧزﯾن ﻣواﻓﻘﺔ اﻟﺿﯾف ﻋﻠﻰ اﺳﺗﺧدام
    ﻣﻠﻔﺎت ﺗﻌرﯾف اﻻرﺗﺑﺎط ﻷﻏراض ﻏﯾر أﺳﺎﺳﯾﺔ
    `,
    },
    {
      cookieKey: 'X-AB',
      domain: 'sc-static.net',
      description: `ﯾﺗم اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﻣن ﻗﺑل ﻣﺷﻐل اﻟﻣوﻗﻊ اﻹﻟﻛﺗروﻧﻲ ﻓﻲ ﺳﯾﺎق اﻻﺧﺗﺑﺎر اﻟﻣﺗﻌدد اﻟﻣﺗﻐﯾرات. وھﻲ أداة ﺗﺳﺗﺧدم ﻟدﻣﺞ أو ﺗﻐﯾﯾر اﻟﻣﺣﺗوى ﻋﻠﻰ اﻟﻣوﻗﻊ. وﯾﺗﯾﺢ ذﻟك ﻟﻠﻣوﻗﻊ اﻹﻟﻛﺗروﻧﻲ ﻣن اﻟﻌﺛور
      ﻋﻠﻰ أﻓﺿل ﻧﺳﺧﺔ/إﺻدار ﻟﻠﻣوﻗﻊ.
      `,
    },
    {
      cookieKey: 'AnalyticsSyncHistory',
      domain: '.linkedin.com',
      description: `ﯾُﺳﺗﺧدم ﻟﺗﺧزﯾن اﻟﻣﻌﻠوﻣﺎت ﺣول اﻟوﻗت اﻟذي ﺗﻣت ﻓﯾﮫ
      اﻟﻣزاﻣﻧﺔ ﻣﻊ ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط
      lms_analytics ﻟﻠﻣﺳﺗﺧدﻣﯾن ﻓﻲ اﻟﺑﻠدان اﻟﻣﻌﯾﻧﺔ.
      `,
    },
    {
      cookieKey: '_gid',
      domain: '.HALA.com',
      description: `ﺗم ﺗﻌﯾﯾن ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ
      .Google Analytics
      ﯾﻘوم ﺑﺗﺧزﯾن وﺗﺣدﯾث
      ﻗﯾﻣﺔ ﻓرﯾدة ﻟﻛل ﺻﻔﺣﺔ ﺗﺗم زﯾﺎرﺗﮭﺎ وﯾﺗم اﺳﺗﺧداﻣﮭﺎ
ﻟﺣﺳﺎب وﺗﺗﺑﻊ ﻣﺷﺎھدات اﻟﺻﻔﺣﺔ.
`,
    },
    {
      cookieKey: '_ga_GVSEJ9RBSQ',
      domain: '.HALA.com',
      description: `ﯾﺗم اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ Analytics Google ﻟﻼﺳﺗﻣرار ﻓﻲ ﺣﺎﻟﺔ اﻟﺟﻠﺳﺔ`,
    },
    {
      cookieKey: '_ga',
      domain: '.HALA.com',
      description: `ﯾرﺗﺑط اﺳم ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑـGoogle Analytics Universal - وھو ﺗﺣدﯾث ﻣﮭم ﻟﺧدﻣﺔ اﻟﺗﺣﻠﯾﻼت اﻷﻛﺛر اﺳﺗﺧداﻣﺎ ﻣن ﻗﺑل. Google ﯾﺗم
      اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﻟﻠﺗﻣﯾﯾز ﺑﯾن اﻟﻣﺳﺗﺧدﻣﯾن اﻟﻔردﯾﯾن ﻋن طرﯾق ﺗﻌﯾﯾن رﻗم ﯾﺗم إﻧﺷﺎؤه ﻋﺷواﺋﯾﺎ ﻛﻣﻌرف ﻟﻠﻌﻣﯾل. ﯾﺗم ﺗﺿﻣﯾﻧﮫ ﻓﻲ ﻛل طﻠب ﺻﻔﺣﺔ ﻓﻲ اﻟﻣوﻗﻊ وﯾﺳﺗﺧدم ﻟﺣﺳﺎب ﺑﯾﺎﻧﺎت اﻟزاﺋر
      واﻟﺟﻠﺳﺔ واﻟﺣﻣﻠﺔ ﻟﺗﻘﺎرﯾر ﺗﺣﻠﯾﻼت اﻟﻣواﻗﻊ.
      `,
    },
    {
      cookieKey: '_ga_E8JBXT22RD',
      domain: '.HALA.com',
      description: `ﯾﺗم اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ
      Analytics Google ﻟﻼﺳﺗﻣرار ﻓﻲ ﺣﺎﻟﺔ اﻟﺟﻠﺳﺔ.
      `,
    },
    {
      cookieKey: '_ga_SVEVR9N0W4',
      domain: '.HALA.com',
      description: `ﯾﺗم اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ
      Analytics Google ﻟﻼﺳﺗﻣرار ﻓﻲ ﺣﺎﻟﺔ اﻟﺟﻠﺳﺔ.
      `,
    },
    {
      cookieKey: 'lidc',
      domain: '.linkedin.com',
      description: `ھذا ھو ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط اﻟﺧﺎص ﺑﺎﻟطرف اﻷول ﻟـ MSN Microsoft واﻟذي ﯾﺿﻣن اﻟﺗﺷﻐﯾل اﻟﺳﻠﯾم ﻟﮭذا
      اﻟﻣوﻗﻊ.
      `,
    },
    {
      cookieKey: '_gat_gtag_UA_252393352_1',
      domain: '.HALA.com',
      description: `ﯾﻌد ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺟزءا ﻣن Google Analytics وﯾﺳﺗﺧدم ﻟﻠﺣد ﻣن اﻟطﻠﺑﺎت ( ﺗﻘﻠﯾل ﻣﻌدل
      اﻟطﻠب.)
      `,
    },
    {
      cookieKey: 'CLID',
      domain: 'www.clarity.ms',
      description: `ﻋﺎدة ﻣﺎ ﯾﺗم ﺗﻌﯾﯾن ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ Dstillery ﻟﺗﻣﻛﯾن ﻣﺷﺎرﻛﺔ ﻣﺣﺗوى اﻟوﺳﺎﺋط ﻋﻠﻰ وﺳﺎﺋل اﻟﺗواﺻل اﻻﺟﺗﻣﺎﻋﻲ. وﻗد ﺗﻘوم أﯾﺿﺎ ﺑﺟﻣﻊ ﻣﻌﻠوﻣﺎت ﻋن زوار اﻟﻣوﻗﻊ اﻹﻟﻛﺗروﻧﻲ ﻋﻧدﻣﺎ ﯾﺳﺗﺧدﻣون وﺳﺎﺋل اﻟﺗواﺻل اﻻﺟﺗﻣﺎﻋﻲ ﻟﻣﺷﺎرﻛﺔ ﻣﺣﺗوى اﻟﻣوﻗﻊ اﻹﻟﻛﺗروﻧﻲ ﻣن اﻟﺻﻔﺣﺔ اﻟﺗﻲ ﺗﻣت
      زﯾﺎرﺗﮭﺎ.
      `,
    },
    {
      cookieKey: 'MUID',
      domain: '.clarity.ms',
      description: `ﯾﺗم اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﻋﻠﻰ ﻧطﺎق
      واﺳﻊ ﻣن ﻗﺑل Microsoft ﻛﻣﻌرف ﻣﺳﺗﺧدم ﻓرﯾد. ﯾﻣﻛن ﺿﺑطﮫ ﺑواﺳطﺔ ﻧﺻوص Microsoftاﻟﻣﺿﻣﻧﺔ. ﯾُﻌﺗﻘد ﻋﻠﻰ ﻧطﺎق واﺳﻊ أﻧﮫ ﯾﻌﻣل ﻣزاﻣﻧﺔ ﻋﺑر اﻟﻌدﯾد ﻣن ﻣﺟﺎﻻت Microsoft
      اﻟﻣﺧﺗﻠﻔﺔ، ﻣﻣﺎ ﯾﺗﯾﺢ ﺗﺗﺑﻊ اﻟﻣﺳﺗﺧدم.
      `,
    },
    {
      cookieKey: '_scid',
      domain: '.HALA.com',
      description: `ﺗﺳﺗﺧدم ﻟﻠﻣﺳﺎﻋدة ﻓﻲ اﻟﺗﻌرف ﻋﻠﻰ اﻟزاﺋر.`,
    },

    {
      cookieKey: 'MR',
      domain: '.c.bing.com',
      description: `
      ھذا ھو ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط اﻟﺧﺎص ﺑﺎﻟطرف اﻷول ﻟـ
      MSN Microsoft واﻟذي ﯾُﺳﺗﺧدم ﻟﻘﯾﺎس اﺳﺗﺧدام
      اﻟﻣوﻗﻊ اﻹﻟﻛﺗروﻧﻲ ﻟﻠﺗﺣﻠﯾﻼت اﻟداﺧﻠﯾﺔ.
      `,
    },
    {
      cookieKey: 'bcookie',
      domain: '.linkedin.com',
      description: `ھذا ھو ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط اﻟﺧﺎص ﺑﺎﻟطرف اﻷول ﻟـ
      MSN Microsoft ﻟﻣﺷﺎرﻛﺔ ﻣﺣﺗوى اﻟﻣوﻗﻊ
      اﻹﻟﻛﺗروﻧﻲ ﻋﺑر وﺳﺎﺋل اﻟﺗواﺻل اﻻﺟﺗﻣﺎﻋﻲ.
      `,
    },

    {
      cookieKey: 'guest_id',
      domain: '.twitter.com',
      description: `ﯾﺗم ﺗﻌﯾﯾن ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ ﺗوﯾﺗر
      ﻟﺗﺣدﯾد وﺗﺗﺑﻊ زاﺋر اﻟﻣوﻗﻊ.
      `,
    },
    {
      cookieKey: 'SRM_B',
      domain: '.c.bing.com',
      description: `ھذا ھو ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط اﻟﺧﺎص ﺑﺎﻟطرف اﻷول ﻟـ
      MSN Microsoftواﻟذي ﯾﺿﻣن اﻟﺗﺷﻐﯾل اﻟﺳﻠﯾم ﻟﮭذا
      اﻟﻣوﻗﻊ.
      `,
    },
    {
      cookieKey: 'SM',
      domain: '.c.clarity.ms',
      description: `هذا هو ملف تعريف الارتباط الطرف الاول لـ Microsoft MSN والذي يستخدم لقياس استخدام الموقع للتحليلات الداخلية `,
    },

    {
      cookieKey: '_gcl_au',
      domain: '.HALA.com',
      description: `ﯾﺳﺗﺧدﻣﮫ AdSense Google ﻻﺧﺗﺑﺎر ﻛﻔﺎءة اﻹﻋﻼن ﻋﻠﻰ اﻟﻣواﻗﻊ اﻹﻟﻛﺗروﻧﯾﺔ اﻟﺗﻲ
      ﺗﺳﺗﺧدم ﺧدﻣﺎﺗﮫ.
      `,
    },
    {
      cookieKey: 'test_cookie',
      domain: '.doubleclick.net',
      description: `ﯾﺗم ﺗﻌﯾﯾن ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ DoubleClick (اﻟﻣﻣﻠوﻛﺔ ﻣن ﻗﺑل ﺷرﻛﺔ Google) ﻟﺗﺣدﯾد ﻣﺎ إذا
      ﻛﺎن ﻣﺗﺻﻔﺢ زاﺋر اﻟﻣوﻗﻊ اﻹﻟﻛﺗروﻧﻲ ﯾدﻋم
      ﻣﻠﻔﺎت ﺗﻌرﯾف اﻻرﺗﺑﺎط.
      `,
    },
    {
      cookieKey: 'bscookie',
      domain: '.www.linkedin.com',
      description: `ﺗﺳﺗﺧدﻣﮫ ﺧدﻣﺔ اﻟﺷﺑﻛﺎت اﻻﺟﺗﻣﺎﻋﯾﺔ LinkedIn ﻟﺗﺗﺑﻊ
      اﺳﺗﺧدام اﻟﺧدﻣﺎت اﻟﻣﺿﻣﻧﺔ.
      `,
    },
    {
      cookieKey: 'MR',
      domain: '.c.clarity.ms',
      description: `ھذا ھو ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط اﻟﺧﺎص ﺑﺎﻟطرف اﻷول ﻟـ
      MSN Microsoftواﻟذي ﯾُﺳﺗﺧدم ﻟﻘﯾﺎس اﺳﺗﺧدام
      اﻟﻣوﻗﻊ اﻹﻟﻛﺗروﻧﻲ ﻟﻠﺗﺣﻠﯾﻼت اﻟداﺧﻠﯾﺔ.
      `,
    },
    {
      cookieKey: 'personalization_id',
      domain: '.twitter.com',
      description: `ﯾﺣﻣل ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﻣﻌﻠوﻣﺎت ﺣول ﻛﯾﻔﯾﺔ اﺳﺗﺧدام اﻟﻣﺳﺗﺧدم اﻟﻧﮭﺎﺋﻲ ﻟﻠﻣوﻗﻊ وأي إﻋﻼﻧﺎت ﻗد ﯾﻛون
      اﻟﻣﺳﺗﺧدم اﻟﻧﮭﺎﺋﻲ ﻗد ﺷﺎھدھﺎ ﻗﺑل زﯾﺎرة اﻟﻣوﻗﻊ اﻟﻣذﻛور.
      `,
    },
    {
      cookieKey: 'sc_at',
      domain: '.snapchat.com',
      description: `ﯾﺳﺗﺧدم ﻟﺗﺣدﯾد اﻟزاﺋر ﻋﺑر ﻣﺟﺎﻻت ﻣﺗﻌددة.`,
    },
    {
      cookieKey: 'IDE',
      domain: '.doubleclick.net',
      description: `ﯾﺗم ﺗﻌﯾﯾن ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺑواﺳطﺔ Doubleclick وﯾﺣﻣل ﻣﻌﻠوﻣﺎت ﺣول ﻛﯾﻔﯾﺔ اﺳﺗﺧدام اﻟﻣﺳﺗﺧدم اﻟﻧﮭﺎﺋﻲ ﻟﻠﻣوﻗﻊ اﻻﻟﻛﺗروﻧﻲ وأي إﻋﻼﻧﺎت ﻗد ﯾﻛون اﻟﻣﺳﺗﺧدم اﻟﻧﮭﺎﺋﻲ ﻗد ﺷﺎھدھﺎ ﻗﺑل زﯾﺎرة اﻟﻣوﻗﻊ
      اﻹﻟﻛﺗروﻧﻲ اﻟﻣذﻛور.

              `,
    },
    {
      cookieKey: '_gat_gtag_UA_252393352_2',
      domain: '.HALA.com',
      description: `ﯾﻌد ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﺟزء ﻣن Analytics Google
      وﯾﺳﺗﺧدم ﻟﻠﺣد ﻣن اﻟطﻠﺑﺎت ( ﺗﻘﻠﯾل ﻣﻌدل اﻟطﻠب).

                `,
    },
    {
      cookieKey: '_fbp',
      domain: '.HALA.com',
      description: `تستخدمه Meta لتقديم سلسلة من المنتجات الإعلانية مثل تقديم العطاءات في الوقت الفعلي من معلنين خارجيين.`,
    },
    {
      cookieKey: 'UserMatchHistory',
      domain: '.linkedin.com',
      description: `يتم اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﻟﺗﺗﺑﻊ اﻟزاﺋرﯾن ﺑﺣﯾث ﯾﻣﻛن ﻋرض إﻋﻼﻧﺎت أﻛﺛر ﺻﻠﺔ ﺑﻧﺎء ﻋﻠﻰ
      ﺗﻔﺿﯾﻼت اﻟزاﺋر.
      `,
    },
    {
      cookieKey: 'MUID',
      domain: '.bing.com',
      description: `ﯾﺗم اﺳﺗﺧدام ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﻋﻠﻰ ﻧطﺎق
      واﺳﻊ ﻣن ﻗﺑل Microsoft ﻛﻣﻌرف ﻣﺳﺗﺧدم ﻓرﯾد.
      ﯾﻣﻛن ﺿﺑطﮫ ﺑواﺳطﺔ ﻧﺻوص Micrisoft اﻟﻣﺿﻣﻧﺔ. ﯾُﻌﺗﻘد ﻋﻠﻰ ﻧطﺎق واﺳﻊ أﻧﮫ ﯾﻌﻣل ﻣزاﻣﻧﺔ
      ﻋﺑر اﻟﻌدﯾد ﻣن ﻣﺟﺎﻻت Microsoft المختلفة، مما يسمح بتتبع المستخدم
      `,
    },

    {
      cookieKey: 'ANONCHK',
      domain: '.c.clarity.ms',
      description: `ﯾﺣﻣل ﻣﻠف ﺗﻌرﯾف اﻻرﺗﺑﺎط ھذا ﻣﻌﻠوﻣﺎت ﺣول ﻛﯾﻔﯾﺔ اﺳﺗﺧدام اﻟﻣﺳﺗﺧدم اﻟﻧﮭﺎﺋﻲ ﻟﻠﻣوﻗﻊ وأي إﻋﻼﻧﺎت ﻗد ﯾﻛون اﻟﻣﺳﺗﺧدم اﻟﻧﮭﺎﺋﻲ ﻗد ﺷﺎھدھﺎ ﻗﺑل زﯾﺎرة
      اﻟﻣوﻗﻊ اﻟﻣذﻛور.
      `,
    },
    {
      cookieKey: 'guest_id_marketing',
      domain: '.twitter.com',
      description: `ﺗوﯾﺗر ﺑﻛﺳل`,
    },

    {
      cookieKey: 'guest_id_ads',
      domain: '.twitter.com',
      description: `ﺗوﯾﺗر ﺑﻛﺳل`,
    },
    {
      cookieKey: '_ttp',
      domain: '.Tiktok.com',
      description: `ﺗﯾك ﺗوك ﺑﻛﺳل`,
    },
  ];

  ngOnInit(): void {
    this.language = this._websiteService.language;
  }
}
